import { render, staticRenderFns } from "./StudentResultRow.vue?vue&type=template&id=4a164fa2&scoped=true"
import script from "./StudentResultRow.vue?vue&type=script&lang=js"
export * from "./StudentResultRow.vue?vue&type=script&lang=js"
import style0 from "./StudentResultRow.vue?vue&type=style&index=0&id=4a164fa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a164fa2",
  null
  
)

export default component.exports